<script setup lang="ts">
const {
  open,
  title,
  submitLabel,
  cancelLabel,
  pending = false,
  canSubmit = true,
} = defineProps<{
  open: boolean;
  title: string;
  submitLabel: string;
  cancelLabel: string;
  pending?: boolean;
  canSubmit?: boolean;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'submit'): void;
}>();

const onSubmit = () => {
  if (canSubmit && !pending) emit('submit');
};
</script>

<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4"
      @click.self="emit('close')"
    >
      <form
        class="flex w-full max-w-[480px] flex-col gap-4 rounded-2xl bg-white p-6 shadow-xl"
        role="dialog"
        aria-modal="true"
        :aria-label="title"
        @submit.prevent="onSubmit"
      >
        <h2 class="text-lg font-semibold text-[#0D0F15]">{{ title }}</h2>
        <slot />
        <div class="flex justify-end gap-2">
          <button
            type="button"
            class="h-10 rounded-lg border border-black/[0.14] px-4 text-sm font-semibold text-black-80"
            @click="emit('close')"
          >
            {{ cancelLabel }}
          </button>
          <button
            type="submit"
            class="h-10 rounded-lg bg-[#0D0F15] px-4 text-sm font-semibold text-white disabled:opacity-40"
            :disabled="!canSubmit || pending"
          >
            {{ submitLabel }}
          </button>
        </div>
      </form>
    </div>
  </Teleport>
</template>
